const BILLING_SNAPSHOT_KEY = 'locshark_billing_before_portal';

export const buildBillingFingerprint = (activePlan) => {
  if (!activePlan) {
    return null;
  }

  const billingPlanId = activePlan?.billing?._id || activePlan?.billing;
  const addonIds = Array.isArray(activePlan?.addons)
    ? activePlan.addons.map(String).sort()
    : [];

  return {
    billingPlanId: billingPlanId ? String(billingPlanId) : '',
    billingPeriod: activePlan?.subscription?.billingPeriod || 'monthly',
    addons: addonIds.join(','),
    subscriptionStatus: activePlan?.subscriptionStatus || '',
  };
};

export const saveBillingSnapshot = (activePlan) => {
  const fingerprint = buildBillingFingerprint(activePlan);
  if (!fingerprint?.billingPlanId) {
    return;
  }
  sessionStorage.setItem(BILLING_SNAPSHOT_KEY, JSON.stringify(fingerprint));
};

export const loadBillingSnapshot = () => {
  try {
    const raw = sessionStorage.getItem(BILLING_SNAPSHOT_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const clearBillingSnapshot = () => {
  sessionStorage.removeItem(BILLING_SNAPSHOT_KEY);
};

export const billingFingerprintChanged = (before, after) => {
  if (!before || !after) {
    return false;
  }
  return before.billingPlanId !== after.billingPlanId
    || before.billingPeriod !== after.billingPeriod
    || before.addons !== after.addons
    || before.subscriptionStatus !== after.subscriptionStatus;
};
